/* gc-cfg.js — 手作皮具定制器行为（自有实现，行为对齐参考站）
 * 结构：选项标记由 snippets/gc-cfg-*.liquid 服务端渲染；本脚本负责
 *   条件显示（Advance / Custom / Other / 自带扣 / 定制厚度）、厚度随形状、选择提示「— 值」、
 *   原生变体联动（Buckle Finish → Buckle Type；Curved End 样式 + 加价提示）、property 挂到 Horizon 商品表单（form="id"）、
 *   加购校验、图片放大灯箱、尺寸指南弹窗。
 */
(function () {
  'use strict';
  if (window.__gcCfgInit) return; window.__gcCfgInit = true;

  var THICK = { 'Padded Ridge': ['4.5 mm', '5.0 mm', '5.5 mm'], 'Padded Step': ['4.5 mm', '5.0 mm'], 'Flat': ['2.5 mm', '3.5 mm', '4.5 mm'], 'Padded': ['3.5 mm', '4.5 mm', '5.0 mm', '5.5 mm'], 'Padded Square': ['3.5 mm', '4.5 mm'], 'Padded Domed': ['3.5 mm', '4.5 mm', '5.0 mm', '5.5 mm'] };
  var GUIDE_KEYS = [['Strap Form', 'form'], ['Thickness', 'thickness'], ['Lug Width', 'lug'], ['Length', 'length'], ['Padding', 'padding'], ['Curved End', 'curved'], ['Wings Cut', 'wingcut'], ['Middle Cut', 'middlecut']];

  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function root() { return q('[data-gc-cfg]'); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function vis(el) { return !!el && el.offsetParent !== null; }
  function setT(el, t) { if (el && el.textContent !== t) el.textContent = t; }   // 只在变了才写（同值写也会触发 mutation → 观察器死循环）

  var VARIANTS = [];
  try { var vj = q('[data-gc-variants]'); if (vj) VARIANTS = JSON.parse(vj.textContent) || []; } catch (e) { VARIANTS = []; }

  /* ---------- 商品表单（Horizon：product-form-component 里的 form） ---------- */
  function productForm() {
    var r = root(); if (!r) return null;
    var sec = r.closest('section, .shopify-section, product-information, main') || document;
    return q('product-form-component form', sec) || q('form[action*="/cart/add"]', sec) || q('product-form-component form') || q('form[action*="/cart/add"]');
  }
  function wireForm() {
    var r = root(), f = productForm(); if (!r || !f) return;
    var id = f.getAttribute('id');
    if (!id) { id = 'gc-pform-' + Math.random().toString(36).slice(2); f.setAttribute('id', id); }
    if (f.getAttribute('enctype') !== 'multipart/form-data') f.setAttribute('enctype', 'multipart/form-data');
    qa('[name^="properties"]', r).forEach(function (el) { if (el.getAttribute('form') !== id) el.setAttribute('form', id); });
  }

  /* ---------- 显示 / 隐藏（隐藏时禁用 + 清空 + 取消必填，显示时恢复） ---------- */
  function show(box, on) {
    if (!box) return;
    box.style.display = on ? 'block' : 'none';
    qa('input,select,textarea', box).forEach(function (i) {
      if (on) { i.disabled = false; if (i.type !== 'checkbox') i.setAttribute('required', 'required'); }
      else {
        i.disabled = true; i.removeAttribute('required');
        if (i.type === 'radio' || i.type === 'checkbox') i.checked = false;
        else if (i.tagName === 'INPUT' || i.tagName === 'TEXTAREA') i.value = '';
      }
    });
  }

  /* ---------- 标签里的「— 当前值」提示 ---------- */
  function hintSpan(lbl) {
    var sp = lbl.querySelector('.gc-sel');
    if (!sp) {
      sp = document.createElement('span'); sp.className = 'gc-sel';
      var qb = lbl.querySelector('.gc-q'); if (qb) lbl.insertBefore(sp, qb); else lbl.appendChild(sp);
    }
    return sp;
  }
  function selText(s) { var o = s.options[s.selectedIndex]; return (o && o.text) || s.value || ''; }
  function swHint(attr, hintAttr) {
    var r = root(); if (!r) return;
    var t = q('[' + hintAttr + ']', r); if (!t) return;
    var c = q('input[' + attr + ']:checked:not([disabled])', r);
    setT(t, c ? ('— ' + c.value + (/butterfly/i.test(c.value) ? ' (+$10)' : '')) : '');
  }
  function autoHints() {
    var r = root(); if (!r) return;
    qa('.gc-f', r).forEach(function (fld) {
      var s = fld.querySelector(':scope > select'), lbl = fld.querySelector(':scope > .gc-l');
      if (!s || !lbl) return;
      var t = selText(s);
      setT(hintSpan(lbl), (t && !s.disabled && vis(fld)) ? ('— ' + t) : '');
    });
    // 形状卡片
    qa('.gc-cards', r).forEach(function (grp) {
      var ck = q('input:checked', grp);
      qa('.gc-card', grp).forEach(function (c) { var i = q('input', c), on = !!(i && i.checked); if (c.classList.contains('gc-card--on') !== on) c.classList.toggle('gc-card--on', on); });
      var lbl = grp.closest('.gc-f') && grp.closest('.gc-f').querySelector(':scope > .gc-l');
      if (lbl) setT(hintSpan(lbl), ck ? ('— ' + ck.value) : '');
    });
  }

  /* ---------- 厚度随形状 ---------- */
  function updThickness() {
    var r = root(); if (!r) return;
    var th = q('[data-gc-thickness]', r); if (!th) return;
    var fc = q('[data-gc-form]:checked', r), fs = q('select[data-gc-form]', r);
    var fv = fc ? fc.value : (fs ? fs.value : '');
    if (th.getAttribute('data-form') === fv && th.options.length > 1) return;
    th.setAttribute('data-form', fv);
    var prev = th.value, opts = THICK[fv] || [];
    var html = '<option value="" disabled selected>' + (fv ? 'Select thickness' : 'Select form first') + '</option>';
    opts.forEach(function (o) { html += '<option value="' + o + '">' + o + '</option>'; });
    if (fv) html += '<option value="Request">Request custom thickness</option>';
    th.innerHTML = html;
    if (prev && (opts.indexOf(prev) >= 0 || prev === 'Request')) th.value = prev;
  }

  /* ---------- 原生变体联动 ---------- */
  function nativeOptions() {
    // 返回 [{name, idx, sel, wrap, lbl}]
    var out = [];
    qa('select[name^="options["]').forEach(function (s) {
      if (s.closest('[data-gc-cfg]')) return;
      var nm = s.name.replace(/^options\[|\]$/g, '');
      var wrap = s.closest('.variant-option, .product-form__input, fieldset, .variant-picker__option') || s.parentElement;
      var lbl = wrap ? (wrap.querySelector('label, legend')) : null;
      out.push({ name: nm, sel: s, wrap: wrap, lbl: lbl });
    });
    return out;
  }
  function optIndexByName(name) {
    var names = qa('select[name^="options["]').filter(function (s) { return !s.closest('[data-gc-cfg]'); }).map(function (s) { return s.name.replace(/^options\[|\]$/g, ''); });
    return names.indexOf(name);
  }
  function priceDelta(opts, target, value) {
    // 目标选项取 value、其它选项保持当前值的变体价 − 目标选项取第一个值时的价
    if (!VARIANTS.length) return 0;
    var cur = opts.map(function (o) { return o.sel.value; });
    var ti = opts.indexOf(target);
    function find(v) {
      for (var i = 0; i < VARIANTS.length; i++) {
        var ok = true;
        for (var k = 0; k < opts.length; k++) { var want = (k === ti) ? v : cur[k]; if (VARIANTS[i].o[k] !== want) { ok = false; break; } }
        if (ok) return VARIANTS[i];
      }
      return null;
    }
    var base = find(target.sel.options[0] && target.sel.options[0].value);
    var mine = find(value);
    return (base && mine) ? (mine.price - base.price) : 0;
  }
  function nativeSync() {
    var r = root(); if (!r) return;
    var opts = nativeOptions();
    opts.forEach(function (o) {
      if (/buckle type/i.test(o.name)) {
        // 隐藏，由 Buckle Finish 决定（选蝴蝶扣 → Butterfly Clasp）
        if (o.wrap && !o.wrap.classList.contains('gc-hide-native')) o.wrap.classList.add('gc-hide-native');
        var b = q('[data-gc-buckle]:checked', r);
        var want = (b && /butterfly/i.test(b.value)) ? 'Butterfly Clasp' : 'Standard';
        if (o.sel.value !== want) {
          for (var i = 0; i < o.sel.options.length; i++) {
            if (o.sel.options[i].value === want || o.sel.options[i].text === want) { o.sel.selectedIndex = i; o.sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
          }
        }
      } else {
        // 样式对齐 + 加价提示 + 「— 值」
        if (o.wrap && !o.wrap.classList.contains('gc-native-f')) o.wrap.classList.add('gc-native-f');
        if (o.lbl && !o.lbl.classList.contains('gc-native-l')) o.lbl.classList.add('gc-native-l');   // 参考站原生标签：「CURVED END ? *」，不带「— 值」
        qa('option', o.sel).forEach(function (op) {
          var base = op.getAttribute('data-gc-t'); if (base === null) { base = op.text; op.setAttribute('data-gc-t', base); }
          var dlt = priceDelta(opts, o, op.value);
          var want = base + (dlt > 0 ? ' (+' + money(dlt) + ')' : '');
          if (op.text !== want) op.text = want;
        });
      }
      // 订单里也记一份（跟参考站一致）
      var mirror = q('input[data-gc-optprop="' + o.name.replace(/"/g, '\\"') + '"]', r);
      if (mirror && mirror.value !== o.sel.value) mirror.value = o.sel.value;
    });
  }


  /* ================= 钥匙套定制器（data-gc-kind=keyfob） ================= */
  var KF = null;
  var ZOOM_SVG = '<svg viewBox="0 0 16 16" width="11" height="11" fill="none" stroke="#1a1a1a" stroke-width="1.6" aria-hidden="true"><circle cx="7" cy="7" r="5"></circle><line x1="10.8" y1="10.8" x2="15" y2="15"></line></svg>';
  var OPTNAMES = [];
  try { var on = q('[data-gc-optnames]'); if (on) OPTNAMES = JSON.parse(on.textContent) || []; } catch (e) { OPTNAMES = []; }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isKf() { var r = root(); return !!r && r.getAttribute('data-gc-kind') === 'keyfob'; }
  function kq(s) { return KF ? KF.kf.querySelector(s) : null; }
  function kqa(s) { return KF ? qa(s, KF.kf) : []; }
  function kShow(box, on) {
    if (!box) return; box.hidden = !on;
    qa('input,select,textarea', box).forEach(function (i) {
      if (on) i.disabled = false;
      else { i.disabled = true; if (i.type === 'radio' || i.type === 'checkbox') i.checked = false; else if (i.tagName === 'SELECT') i.selectedIndex = 0; else i.value = ''; }
    });
  }
  function kProp(name) {
    var els = kqa('[name="properties[' + name + ']"]');
    for (var i = 0; i < els.length; i++) { var el = els[i]; if (el.disabled) continue; if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) return el.value; } else return el.value || ''; }
    return null;
  }
  function kMode() { var m = kq('[data-logo-mode]'); if (!m) return ''; var o = m.options[m.selectedIndex]; return (o && o.getAttribute('data-mode')) || ''; }
  function kVariantPrice(lt, logo) {
    var iL = -1, iG = -1;
    OPTNAMES.forEach(function (n, i) { if (/leather type/i.test(n)) iL = i; else if (/logo/i.test(n)) iG = i; });
    for (var i = 0; i < VARIANTS.length; i++) { var v = VARIANTS[i]; if ((iL < 0 || v.o[iL] === lt) && (iG < 0 || v.o[iG] === logo)) return v.price; }
    return null;
  }
  function kfInit() {
    var r = root(); if (!r || KF) return;
    var kf = q('[data-gc-kf]', r); if (!kf) return;
    KF = { r: r, kf: kf, logos: null, src: '' };
    var kv = kq('[data-gc-keyver]');
    if (kv) {
      var brand = (kv.getAttribute('data-brand') || '').toUpperCase(), disp = kv.getAttribute('data-display') || brand, def = kv.getAttribute('data-default') || '';
      var grid = kv.querySelector('[data-keyver-grid]'), st = kv.querySelector('[data-keyver-status]');
      fetch(r.getAttribute('data-gc-keys-url')).then(function (x) { return x.json(); }).then(function (man) {
        var items = man.filter(function (m) { return (m.model && m.model.toUpperCase() === brand) || (m.category && m.category.toUpperCase() === brand) || (!m.category && m.brand && m.brand.toUpperCase() === brand); });
        if (!items.length) { if (st) st.textContent = 'Key versions for ' + disp + ' temporarily unavailable.'; return; }
        if (st) st.style.display = 'none';
        kRenderVersions(grid, items, disp, def);
        var pre = grid.querySelector('[data-keyver-pick]:checked'); if (pre) kPickKey(pre);
        refresh();
      }).catch(function () { if (st) st.textContent = 'Could not load key versions. Refresh the page.'; });
    }
    var cas = kq('[data-gc-cascade]'); if (cas) kCascadeInit(cas, r);
    kqa('[data-logo-source]').forEach(function (t) { t.addEventListener('click', function () { kPickSrc(t.getAttribute('data-logo-source')); }); });
    kf.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.matches) return;
      if (t.matches('[data-keyver-pick]')) kPickKey(t);
      if (t.matches('[data-logo-mode]')) kLogoMode();
      if (t.matches('[data-logo-pick]')) kPickLogo(t);
      kqa('.gc-invalid').forEach(function (x) { x.classList.remove('gc-invalid'); });
      soon(20);
    });
    kf.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('[data-tag]')) soon(20); });
    kLogoMode();
  }
  function kRenderVersions(grid, items, disp, def) {
    items.sort(function (a, b) { return (a.num == null ? 1e9 : a.num) - (b.num == null ? 1e9 : b.num); });
    grid.innerHTML = items.map(function (it, i) {
      var v = it.num != null ? it.num : (i + 1);
      return '<label class="gc-sw gc-sw--kf" title="Version ' + v + '"><input type="radio" name="kf-keyver" value="' + esc(it.key) + '" data-keyver-pick' + (def && it.key === def ? ' checked' : '') + '><span class="gc-sw__imgwrap"><img src="' + esc(it.url) + '?width=240" alt="Version ' + v + '" loading="lazy"></span><span class="gc-sw__n">Version ' + v + '</span><button type="button" class="gc-zoom" data-gc-zoom="' + esc(it.url) + '?width=1400" data-gc-zoom-name="' + esc(disp) + ' - Version ' + v + '" aria-label="Zoom">' + ZOOM_SVG + '</button></label>';
    }).join('');
    wireForm();
  }
  /* 通用款「Your Car & Key」：品牌 → 型号 → 钥匙款式（全量清单 gc-kf-keys-all.json，字段 bl / cl = 显示名） */
  function kCascadeInit(cas, r) {
    var bSel = cas.querySelector('[data-cascade-brand]'), mSel = cas.querySelector('[data-cascade-model]'), mWrap = cas.querySelector('[data-cascade-modelwrap]');
    var bVal = cas.querySelector('[data-cascade-brandval]'), mVal = cas.querySelector('[data-cascade-modelval]');
    var grid = cas.querySelector('[data-keyver-grid]'), st = cas.querySelector('[data-keyver-status]');
    var vIn = cas.querySelector('[data-keyver-version]'), iIn = cas.querySelector('[data-keyver-image]');
    if (!bSel || !grid) return;
    var MAN = null, wait = [];
    function status(msg) { if (!st) return; if (msg) { st.hidden = false; setT(st, msg); } else if (!st.hidden) st.hidden = true; }
    function clearVer() { grid.innerHTML = ''; if (vIn) { vIn.value = ''; vIn.disabled = true; } if (iIn) { iIn.value = ''; iIn.disabled = true; } status(''); }
    function render(items, label) { if (!items.length) { grid.innerHTML = ''; status('Key versions for ' + label + ' unavailable - please contact us.'); return; } status(''); kRenderVersions(grid, items, label, ''); }
    function load(cb) {
      if (MAN) { cb(); return; } wait.push(cb); if (wait.length > 1) return;
      fetch(r.getAttribute('data-gc-keys-all-url')).then(function (x) { return x.json(); }).then(function (j) { MAN = j || []; var w = wait; wait = []; w.forEach(function (f) { f(); }); })
        .catch(function () { wait = []; status('Could not load car list. Refresh the page.'); });
    }
    bSel.addEventListener('change', function () {
      var b = bSel.value; if (!b) return;
      if (bVal) { bVal.value = b; bVal.disabled = false; }
      if (mVal) { mVal.value = ''; mVal.disabled = true; }
      clearVer();
      if (!MAN) status('Loading key versions…');
      load(function () {
        if (bSel.value !== b) return;
        var cats = [], seen = {};
        MAN.forEach(function (m) { if (m.bl === b && m.cl && !seen[m.cl]) { seen[m.cl] = 1; cats.push(m.cl); } });
        status('');
        if (cats.length) {
          cats.sort();
          mSel.innerHTML = '<option value="" selected disabled>Choose your model</option>' + cats.map(function (c) { return '<option value="' + esc(c) + '">' + esc(c) + '</option>'; }).join('');
          kShow(mWrap, true);
        } else { kShow(mWrap, false); render(MAN.filter(function (m) { return m.bl === b; }), b); }
        kCascadeSel(); soon(20);
      });
    });
    if (mSel) mSel.addEventListener('change', function () {
      var b = bSel.value, c = mSel.value; if (!c || !MAN) return;
      if (mVal) { mVal.value = c; mVal.disabled = false; }
      if (vIn) { vIn.value = ''; vIn.disabled = true; } if (iIn) { iIn.value = ''; iIn.disabled = true; }
      render(MAN.filter(function (m) { return m.bl === b && m.cl === c; }), c);
      kCascadeSel(); soon(20);
    });
    load(function () {});   // 跟参考站一样页面一开就拉清单
  }
  function kCascadeSel() {
    var cas = kq('[data-gc-cascade]'); if (!cas) return;
    var sel = cas.querySelector('[data-cascade-sel]'); if (!sel) return;
    var p = [], bv = cas.querySelector('[data-cascade-brandval]'), mv = cas.querySelector('[data-cascade-modelval]'), mw = cas.querySelector('[data-cascade-modelwrap]'), vv = cas.querySelector('[data-keyver-version]');
    if (bv && bv.value) p.push(bv.value);
    if (mv && mv.value && mw && !mw.hidden) p.push(mv.value);
    if (vv && vv.value) p.push(vv.value);
    setT(sel, p.length ? ' — ' + p.join(' / ') : '');
  }
  function kPickKey(t) {
    var lbl = t.closest('.gc-sw'), vn = lbl ? lbl.querySelector('.gc-sw__n').textContent.trim() : '', im = lbl ? lbl.querySelector('img') : null;
    var iu = im ? (im.currentSrc || im.src).replace(/\?width=\d+$/, '') : '';
    var vIn = kq('[data-keyver-version]'), iIn = kq('[data-keyver-image]'), sel = kq('[data-keyver-sel]');
    if (vIn) { vIn.value = vn; vIn.disabled = !vn; }
    if (iIn) { iIn.value = iu; iIn.disabled = !iu; }
    if (sel) setT(sel, ' — ' + vn);
    kCascadeSel();
  }
  function kPickSrc(s) {
    if (s !== 'master') return;   // 只保留 Universal（车厂标志不收）
    KF.src = s;
    kqa('[data-logo-source]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-logo-source') === s); });
    var code = kq('[data-logo-code]'), bv = kq('[data-logo-brandval]'), pk = kq('[data-logo-picked]');
    if (code) code.value = ''; if (bv) bv.value = 'Universal'; if (pk) pk.hidden = true;
    kCompose();
    var st = kq('[data-logo-status]'), grid = kq('[data-logo-grid]');
    var go = function (items) {
      if (st) st.textContent = 'Universal - ' + items.length + ' logos:';
      if (grid) grid.innerHTML = items.map(function (it) { return '<label class="gc-sw gc-sw--color" title="' + esc(it.code) + '"><input type="radio" name="logo-pick" value="' + esc(it.code) + '" data-logo-pick><span class="gc-sw__imgwrap"><img src="' + esc(it.thumb) + '" alt="' + esc(it.code) + '" loading="lazy"></span><span class="gc-sw__n">' + esc(it.code) + '</span><button type="button" class="gc-zoom" data-gc-zoom="' + esc(it.full) + '" data-gc-zoom-name="Logo ' + esc(it.code) + '" aria-label="Zoom">' + ZOOM_SVG + '</button></label>'; }).join('');
      wireForm();
    };
    if (KF.logos) { go(KF.logos); return; }
    fetch(KF.r.getAttribute('data-gc-logos-url')).then(function (x) { return x.json(); }).then(function (j) { KF.logos = j || []; go(KF.logos); }).catch(function () { if (st) st.textContent = 'Library temporarily unavailable.'; });
  }
  function kPickLogo(t) {
    var code = kq('[data-logo-code]'), pk = kq('[data-logo-picked]'), pi = kq('[data-logo-picked-img]'), pc = kq('[data-logo-picked-code]'), bv = kq('[data-logo-brandval]');
    if (code) code.value = t.value;
    var im = t.closest('.gc-sw') && t.closest('.gc-sw').querySelector('img');
    if (pk && pi && im) { pi.src = im.src; if (pc) setT(pc, ((bv && bv.value) || '') + ' / ' + t.value); pk.hidden = false; }
    kCompose();
  }
  function kCompose() {
    var label = kq('[data-logo-label]'); if (!label) return;
    if (kMode() !== 'preset') { label.value = ''; label.disabled = true; return; }
    var b = (kq('[data-logo-brandval]') || {}).value || '', c = (kq('[data-logo-code]') || {}).value || '';
    if (!b || !c) { label.value = ''; label.disabled = true; return; }
    label.value = b + ' > ' + c; label.disabled = false;
  }
  function kLogoMode() {
    var md = kMode();
    var up = kq('[data-logo-upload]'), pr = kq('[data-logo-preset]'), file = kq('[data-logo-file]'), code = kq('[data-logo-code]');
    if (up) up.hidden = md !== 'upload';
    if (file) { file.disabled = md !== 'upload'; if (md === 'upload') file.setAttribute('required', 'required'); else file.removeAttribute('required'); }
    if (pr) pr.hidden = md !== 'preset';
    if (code) code.disabled = md !== 'preset';
    if (md === 'preset') { if (!KF.src) kPickSrc('master'); }
    else { var pk = kq('[data-logo-picked]'); if (pk) pk.hidden = true; }
    kCompose();
  }
  function kfRefresh() {
    if (!KF) return;
    // 皮种 → 颜色块
    var ltSel = kq('[data-gc-leathertype]'), lt = ltSel ? ltSel.value : 'Veg Tanned', ep = lt === 'Epsom';
    var vb = kq('[data-lt-block="veg"]'), eb = kq('[data-lt-block="epsom"]');
    if (vb) vb.style.display = ep ? 'none' : '';
    if (eb) eb.style.display = ep ? 'contents' : 'none';
    kqa('[data-color]').forEach(function (i) { i.disabled = ep; if (ep) i.removeAttribute('required'); else i.setAttribute('required', 'required'); });
    kqa('[data-gc-epsomcolor]').forEach(function (i) { i.disabled = !ep; });
    var ls = kq('[data-lt-sel]'); if (ls) setT(ls, ' - ' + lt);
    // 线色 / 边油
    var sm = kq('[data-stitch-mode]'), so = sm && sm.value === 'other';
    var sc = kq('[data-stitch-colors]'); if (sc && sc.hidden === so) kShow(sc, so);
    var rec = kq('[data-stitch-rec]'); if (rec) rec.disabled = so;
    var ss = kq('[data-stitch-sel]'); if (ss) { if (so) { var s1 = kq('[data-stitch-color]:checked'); setT(ss, s1 ? s1.value : 'Choose colour'); } else setT(ss, 'Recommended (tone-on-tone)'); }
    var ed = kq('[data-edge]'), eo = ed && ed.value === 'Painted (other color)';
    var ew = kq('[data-edge-colorwrap]'); if (ew && ew.hidden === eo) kShow(ew, eo);
    var es = kq('[data-edge-sel]'); if (es) setT(es, eo ? ('Other - ' + ((kq('[data-edge-color]:checked') || {}).value || 'choose')) : 'Tone-on-tone');
    // 标志提示
    var lsel = kq('[data-logo-sel]'), md = kMode();
    if (lsel) { var lc = kq('[data-logo-grid] input:checked'); setT(lsel, !md ? '' : md === 'none' ? 'None' : md === 'original' ? 'Original logo' : md === 'upload' ? 'Upload (+$10)' : (lc ? 'Library: ' + lc.value : 'Pick from library')); }
    // 其它提示
    var cov = kq('[data-cover]:checked'), cvs = kq('[data-cover-sel]'); if (cvs) setT(cvs, cov ? cov.value : '');
    var col = kq('[data-color]:checked'), cs = kq('[data-color-sel]'); if (cs) setT(cs, col && !col.disabled ? ' — ' + col.value : '');
    kqa('[data-epsom-field]').forEach(function (f) { var k = f.getAttribute('data-epsom-field'), c = f.querySelector('[data-gc-epsomcolor]:checked'), sp = kq('[data-epsom-sel="' + k + '"]'); if (sp) setT(sp, c ? ' — ' + c.value : ''); });
    var hw = kq('[data-hw]:checked'), hs = kq('[data-hw-sel]'); if (hs) setT(hs, hw ? ' — ' + hw.value : '');
    var tg = kq('[data-tag]'), ts = kq('[data-tag-sel]'); if (ts) setT(ts, tg && tg.value ? ' — ' + tg.value : '');
    kCompose();
    // 小结
    var spec = kq('[data-gc-spec]');
    if (spec) {
      var rows = [['Leather type', ep ? 'Epsom Calfskin' : 'Vegetable Tanned']], addon = 0, addonN = [];
      if (kq('[data-gc-cascade]')) { var kb = kProp('Smart Key Brand'), km = kProp('Smart Key Model'); if (kb) rows.push(['Car brand', kb]); if (km) rows.push(['Model', km]); }
      var ver = kq('[data-keyver-version]'); if (ver && ver.value) rows.push(['Key version', ver.value]);
      var cv = kProp('Cover Style'); if (cv) rows.push(['Cover style', cv]);
      if (ep) { var f1 = kProp('Epsom Front Colour'), f2 = kProp('Epsom Back Colour'); if (f1) rows.push(['Front colour', f1]); if (f2) rows.push(['Back colour', f2]); }
      else { var cl = kProp('Color'); if (cl) { rows.push(['Leather colour', cl]); if (/america/i.test(cl)) { addon += 10; addonN.push('America Flag colour'); } } }
      var h2 = kProp('Hardware'); if (h2) rows.push(['Keychain', h2]);
      var sc2 = kProp('Stitch Color'); if (sc2) rows.push(['Stitch colour', sc2]);
      var em = kProp('Edge Finishing'); if (em) rows.push(['Edge finish', em === 'Painted (other color)' ? ('Painted - ' + (kProp('Edge Color') || 'other')) : 'Painted - matching leather']);
      var lg = kProp('Logo on Back');
      if (lg && lg !== 'No') { var lv = lg; if (lg === 'Upload my own') { lv = 'Custom upload'; addon += 10; addonN.push('Custom logo'); } else if (lg === 'Preset') lv = 'Library: ' + (kProp('Preset Logo') || 'choose'); else if (lg === 'Original Logo') lv = 'Original logo'; rows.push(['Logo on back', lv]); }
      var st2 = kProp('Smart Tag'); if (st2) rows.push(['Smart tag', st2]);
      var html = rows.map(function (x) { return '<li><span class="gc-spec__k">' + esc(x[0]) + '</span><span class="gc-spec__v">' + esc(x[1]) + '</span></li>'; }).join('');
      if (spec.innerHTML !== html) spec.innerHTML = html;
      var base = kVariantPrice(lt, 'No'); if (base == null) base = Math.round(parseFloat(KF.kf.getAttribute('data-gc-base') || '0') * 100);
      var ar = kq('[data-gc-addon-row]'), at = kq('[data-gc-addon-total]'), al = kq('[data-gc-addon-label]'), gr = kq('[data-gc-grand]'), bs = kq('[data-gc-base-show]');
      if (at) setT(at, '+' + money(addon * 100));
      if (al) setT(al, addonN.join(' + '));
      if (ar) { if (addon > 0) ar.removeAttribute('hidden'); else ar.setAttribute('hidden', ''); }
      if (bs) setT(bs, money(base)); if (gr) setT(gr, money(base + addon * 100));
    }
  }
  function kfNative() {
    nativeOptions().forEach(function (o) {
      if (o.wrap && !o.wrap.classList.contains('gc-hide-native')) o.wrap.classList.add('gc-hide-native');
      var want = null;
      if (/leather type/i.test(o.name)) want = (kq('[data-gc-leathertype]') || {}).value || null;
      else if (/logo/i.test(o.name)) want = kMode() === 'upload' ? 'Yes' : 'No';
      if (want != null && o.sel.value !== want) {
        for (var i = 0; i < o.sel.options.length; i++) if (o.sel.options[i].value === want) { o.sel.selectedIndex = i; o.sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
      }
    });
  }
  function kToast(msg, info) {
    var ex = q('.gc-atc-toast'); if (ex) ex.remove();
    var t = document.createElement('div'); t.className = 'gc-atc-toast' + (info ? ' gc-atc-toast--info' : ''); t.setAttribute('role', 'status');
    t.innerHTML = info ? '<i class="gc-atc-spin"></i><span></span>' : '<b>!</b><span></span>'; t.querySelector('span').textContent = msg;
    document.body.appendChild(t); setTimeout(function () { if (t.parentNode) t.remove(); }, info ? 2500 : 4200);
  }
  function kValidate() {
    var fld = function (el) { return el ? (el.closest('.gc-f') || el) : null; };
    var kv = kq('[data-gc-keyver]'), cas = kq('[data-gc-cascade]'), ver = kq('[data-keyver-version]');
    if (kv && (!ver || !ver.value)) return [kv, 'Please pick your exact key version before adding to cart.'];
    if (cas && (!ver || !ver.value)) return [cas, 'Please select your car and exact key version before adding to cart.'];
    if (kq('[data-cover]') && !kq('[data-cover]:checked')) return [fld(kq('[data-cover]')), 'Please choose a cover style.'];
    var lt = (kq('[data-gc-leathertype]') || {}).value;
    if (lt === 'Epsom') { var ef = kqa('[data-epsom-field]'); if (ef[0] && !ef[0].querySelector('[data-gc-epsomcolor]:checked')) return [ef[0], 'Please choose a front colour.']; if (ef[1] && !ef[1].querySelector('[data-gc-epsomcolor]:checked')) return [ef[1], 'Please choose a back colour.']; }
    else if (kq('[data-color]') && !kq('[data-color]:checked')) return [fld(kq('[data-color]')), 'Please choose a leather colour.'];
    if (kq('[data-hw]') && !kq('[data-hw]:checked')) return [fld(kq('[data-hw]')), 'Please choose your keychain hardware.'];
    var sm = kq('[data-stitch-mode]'); if (sm && sm.value === 'other' && !kq('[data-stitch-color]:checked')) return [kq('[data-stitch-colors]'), 'Please choose a stitch colour, or switch back to Recommended.'];
    var ed = kq('[data-edge]'); if (ed && ed.value === 'Painted (other color)' && !kq('[data-edge-color]:checked')) return [kq('[data-edge-colorwrap]'), 'Please choose an edge colour.'];
    var lm = kq('[data-logo-mode]');
    if (lm) { var md = kMode(); if (!md) return [fld(lm), 'Please choose a logo option for the back, or select "No logo".'];
      if (md === 'preset' && !((kq('[data-logo-code]') || {}).value)) return [kq('[data-logo-preset]'), 'Please pick a logo from the library, or choose "No logo".'];
      if (md === 'upload') { var lf = kq('[data-logo-file]'); if (!lf || !lf.files || !lf.files.length) return [kq('[data-logo-upload]'), 'Please upload your logo image, or choose "No logo".']; } }
    return null;
  }

  /* ================= 自己设计表带（.gc-cfg--cc：参考站 custom builder 同款规则，自有实现） =================
   *  标记：snippets/gc-cc-<key>.liquid（tools/gc_cfg_build_custom.php 从参考站标记转换）；实时预览素材：assets/gc-cp-catalog.json
   *  规则要点：皮种（普通 / 异国）→ 皮种下拉（带价）→ 颜色组；款式决定长度 / 表扣 / 翼切中切 / 衬底色；形状 → 厚度；
   *  线迹 / 边油 / 表带圈的自定义色块；小结卡逐行列出可见字段；总价 = 基价（按皮种）+ 各项「+$」→ 选原生 Price 变体。 */
  var CC = null;
  var CC_KINDS = { 'Regular Leather': ['Epsom Calfskin', 'Babele Calfskin', 'Swift', 'Togo Calfskin', 'Pueblo'], 'Exotic Leather (premium upgrade)': ['Lizard (+$44.00)', 'Smooth Ostrich (+$44.00)', 'Ostrich (+$44.00)', 'Alligator / Croc (+$44.00)'] };
  var CC_ALLOW = { regular: ['Epsom Calfskin', 'Togo Calfskin', 'Swift Calfskin', 'Pueblo Calfskin'], exotic: ['Lizard', 'Smooth Ostrich', 'Ostrich', 'Alligator'] };
  var CC_KPRICE = { 'Epsom Calfskin': 75, 'Togo Calfskin': 75, 'Lizard': 119, 'Smooth Ostrich': 109, 'Ostrich': 109, 'Swift Calfskin': 75, 'Pueblo Calfskin': 75, 'Alligator': 119 };
  function isCustom() { var r = root(); return !!r && r.getAttribute('data-gc-kind') === 'custom'; }
  function cq(s) { return CC ? CC.r.querySelector(s) : null; }
  function cqa(s) { return CC ? qa(s, CC.r) : []; }
  function ccStrip(v) { return String(v == null ? '' : v).replace(/\s*\(\+\$[0-9.]+\)/, ''); }
  function ccMoney(n) { return '$' + (n || 0).toFixed(2); }
  function ccNum(p) { return p % 1 ? p.toFixed(2) : String(p); }
  function ccBase() { var b = cq('[data-gc-base]'); return b ? (parseFloat((b.getAttribute('data-gc-base') || '0').replace(/[^0-9.]/g, '')) || 0) : 0; }
  function ccDisp(el, on) { if (!el) return; var w = on ? '' : 'none'; if (el.style.display !== w) el.style.display = w; }
  // 参考站 show()：显示 = 启用 + 必填；隐藏 = 停用 + 取消必填 + 清空
  function ccShow(box, on) {
    if (!box) return;
    var w = on ? 'block' : 'none'; if (box.style.display !== w) box.style.display = w;
    qa('input,select', box).forEach(function (i) {
      if (on) { if (i.disabled) i.disabled = false; if (!i.hasAttribute('required')) i.setAttribute('required', 'required'); }
      else { if (!i.disabled) i.disabled = true; if (i.hasAttribute('required')) i.removeAttribute('required'); if (i.type === 'radio' || i.type === 'checkbox') { if (i.checked) i.checked = false; } else if (i.tagName === 'INPUT' && i.value) i.value = ''; }
    });
  }
  function ccStyle() { return (cq('[data-gc-style]:checked') || {}).value || ''; }
  function ccColor() { var c = cq('[name="properties[Color]"]:checked'); return c ? c.value : 'Black'; }
  function ccSet() { var ct = CC && CC.cat && CC.cat.CT; if (!ct) return null; return ct[ccColor()] || ct['Black'] || null; }
  function ccRacing() { return /racing|underlay/i.test(ccStyle()); }

  function ccInit() {
    var r = root(); if (!r || CC) return;
    CC = { r: r, cat: null, preview: !!r.getAttribute('data-gc-cp-url'), cp: q('#gc-cp', r), revealed: false, lastStyle: null, lastColor: '', kindWant: 'Epsom Calfskin', painted: '' };
    // 款式没选 → 默认 Classic（参考站 lockStyle）
    if (!cq('[data-gc-style]:checked')) { var cl = cq('[data-gc-style][value="Classic"]'); if (cl && CC.preview) cl.checked = true; }
    // 带预览的 3 款：参考站默认普通皮 + Epsom
    var sk = cq('[data-gc-skin]'); if (CC.preview && sk && !sk.value) { for (var i = 0; i < sk.options.length; i++) if (/^regular/i.test(sk.options[i].value)) { sk.selectedIndex = i; break; } }
    // 弯头字段在最前（转换时已挪好）；备注计数
    r.addEventListener('input', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-gc-note]')) { var c = cq('[data-gc-note-count]'); if (c) setT(c, t.value.length + ' of 500 max characters'); } });
    r.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.matches) return;
      if (t.matches('[data-gc-leathercolor]') && t.checked) CC.lastColor = t.value;
      if (t.matches('[data-gc-leatherkind]') && t.value) CC.kindWant = t.value;
    }, true);
    if (CC.preview) {
      fetch(r.getAttribute('data-gc-cp-url')).then(function (x) { return x.json(); }).then(function (j) { CC.cat = j; soon(10); }).catch(function () {});
      if (CC.cp) {
        var st = q('.gc-cp__stage', CC.cp), base = q('.gc-cp__base', CC.cp);
        if (base) { var done = function () { if (st) st.classList.remove('gc-cp--loading'); }; if (base.complete) done(); else base.addEventListener('load', done); }
        if (st) st.addEventListener('click', ccZoom);
        var tg = document.createElement('button'); tg.type = 'button'; tg.className = 'gc-cp__toggle'; tg.setAttribute('data-gc-cp-toggle', ''); tg.textContent = '✕';
        tg.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          var c = CC.cp.classList.toggle('gc-cp--collapsed'); tg.textContent = c ? '▾  Show live preview' : '✕';
          if (window.innerWidth > 749) { var mg = ccGallery(); if (mg) { if (c) mg.style.removeProperty('display'); else mg.style.setProperty('display', 'none', 'important'); } }
        });
        CC.cp.appendChild(tg);
        window.addEventListener('resize', function () { ccPlace(); });
        window.addEventListener('scroll', ccStick, { passive: true });
      }
    }
  }

  /* 皮种下拉：带预览的 3 款按皮价表（参考站 MG_KPRICE，偏移 = 本品基价 − Epsom 价）；自己搭那款按「+$44」加价 */
  function ccKinds() {
    var sk = cq('[data-gc-skin]'), k = cq('[data-gc-leatherkind]'); if (!sk || !k) return;
    var base = ccBase(), list;
    if (CC.preview) {
      var allow = sk.value ? (/exotic/i.test(sk.value) ? CC_ALLOW.exotic : CC_ALLOW.regular) : [];
      var KP = (CC.cat && CC.cat.KPRICE) || CC_KPRICE, off = base - (KP['Epsom Calfskin'] || base);
      list = allow.map(function (n) { var p = KP[n] != null ? KP[n] + off : base; return [n, n + (p ? ' ($' + ccNum(p) + ')' : '')]; });
    } else {
      list = (CC_KINDS[sk.value] || []).map(function (x) { var m = x.match(/\+\$([0-9.]+)/), p = base + (m ? parseFloat(m[1]) : 0); return [x, ccStrip(x) + (p ? ' ($' + ccNum(p) + ')' : '')]; });
    }
    var sig = sk.value + '~' + list.map(function (x) { return x[0] + '|' + x[1]; }).join('~');
    if (k.getAttribute('data-sig') === sig) return;
    var cur = k.value, want = list.some(function (x) { return x[0] === cur; }) ? cur : '';
    if (!want && CC.preview && list.some(function (x) { return x[0] === CC.kindWant; })) want = CC.kindWant;
    k.innerHTML = '<option value="" disabled' + (want ? '' : ' selected') + '>Select leather</option>' + list.map(function (x) { return '<option value="' + esc(x[0]) + '"' + (x[0] === want ? ' selected' : '') + '>' + esc(x[1]) + '</option>'; }).join('');
    k.setAttribute('data-sig', sig);
  }
  /* 颜色组：皮种名里含哪个组名就显示哪组（ostrich 遇到 smooth 不算）；显示的组挪到 Epsom 组后面；换皮种沿用上次的皮色 */
  function ccColorsets() {
    var k = cq('[data-gc-leatherkind]'), kv = ((k && k.value) || '').toLowerCase(), shown = null, eps = cq('[data-gc-colorset="epsom"]');
    cqa('[data-gc-colorset]').forEach(function (set) {
      var key = set.getAttribute('data-gc-colorset'), on = !!kv && kv.indexOf(key) >= 0;
      if (key === 'ostrich' && kv.indexOf('smooth') >= 0) on = false;
      ccShow(set, on);
      if (on) { shown = set; if (eps && set !== eps && eps.parentNode && set.previousElementSibling !== eps) eps.parentNode.insertBefore(set, eps.nextSibling); }
    });
    if (shown && CC.lastColor && !q('[data-gc-leathercolor]:checked', shown)) {
      var w = qa('[data-gc-leathercolor]', shown).filter(function (i) { return i.value === CC.lastColor && !i.disabled; })[0];
      if (w) w.checked = true;
    }
  }
  /* 衬里：有材质下拉的（Classic）按材质切色组，每组默认第一个；其它款默认第一个 */
  function ccLining() {
    var m = cq('[data-gc-liningmat]');
    if (m) {
      cqa('[data-gc-liningcs]').forEach(function (g) {
        var on = g.getAttribute('data-gc-liningcs') === m.value; ccDisp(g, on);
        var ins = qa('input[data-gc-lining]', g); ins.forEach(function (i) { if (i.disabled === on) i.disabled = !on; });
        if (on && ins.length && !ins.some(function (i) { return i.checked; })) ins[0].checked = true;
      });
    } else { var lin = cqa('input[data-gc-lining]'); if (lin.length && !lin.some(function (i) { return i.checked; })) lin[0].checked = true; }
    var c = cq('input[data-gc-lining]:checked:not([disabled])'), nm = '';
    if (c) { var l = c.closest('label'), n = l && q('.gc-sw__n', l); nm = n ? n.textContent.trim() : ccStrip(c.value); }
    cqa('[data-gc-lining-sel],[data-gc-liningepsom-sel],[data-gc-liningswift-sel]').forEach(function (s) { setT(s, nm ? '— ' + nm : ''); });
  }
  /* 厚度随形状（没选形状保持「Select form first」） */
  function ccThickness() {
    var th = cq('[data-gc-thickness]'), fc = cq('[data-gc-form]:checked'); if (!th || !fc) return;
    var fv = fc.value; if (th.getAttribute('data-form') === fv) return;
    th.setAttribute('data-form', fv);
    var prev = th.value, T = (CC.cat && CC.cat.THICK) || THICK, opts = T[fv] || [];
    var html = '<option value="" disabled selected>' + (fv ? 'Select thickness' : 'Select form first') + '</option>';
    opts.forEach(function (o) { html += '<option value="' + o + '">' + o + '</option>'; });
    if (fv) html += '<option value="Request">Request custom thickness</option>';
    th.innerHTML = html;
    if (prev && (opts.indexOf(prev) >= 0 || prev === 'Request')) th.value = prev;
  }
  /* 款式 / 下拉带出的显示规则（参考站 builder 脚本 + 预览脚本里的字段部分） */
  function ccReveals() {
    var lg = cq('[data-gc-lug]'); if (lg) ccShow(cq('[data-gc-adv-lug]'), /advance/i.test(selText(lg)));
    var sty = ccStyle(), DBL = /double folding/i.test(sty), SGL = /single folding/i.test(sty);
    var L = cq('[data-gc-length]'), SL = cq('[data-gc-slength]'), DL = cq('[data-gc-dbl-length]');
    ccShow(cq('[data-gc-normal-length]'), !DBL && !SGL); ccShow(cq('[data-gc-single-length]'), SGL); ccShow(cq('[data-gc-double-length]'), DBL);
    ccShow(cq('[data-gc-adv-length]'), (!DBL && !SGL && !!L && /advance/i.test(L.value)) || (SGL && !!SL && /other/i.test(SL.value)));
    ccShow(cq('[data-gc-double-adv-length]'), DBL && !!DL && /custom/i.test(DL.value || ''));
    ccThickness(); ccShow(cq('[data-gc-adv-thickness]'), /request/i.test((cq('[data-gc-thickness]') || {}).value || ''));
    var E = cq('[data-gc-edge]'); if (E) ccShow(cq('[data-gc-edge-color]'), /other/i.test(E.value));
    var SM = cq('[data-gc-stitch-mode]'); if (SM) ccShow(cq('[data-gc-stitch-swatch]'), /custom/i.test(SM.value));
    var FOLD = /folding/i.test(sty); ccShow(cq('[data-gc-folding-buckle]'), FOLD); ccShow(cq('[data-gc-normal-buckle]'), !FOLD);
    var BK = (FOLD ? (cq('[data-gc-fbuckle]:checked') || {}).value : (cq('[data-gc-buckle]:checked') || {}).value) || '';
    ccShow(cq('[data-gc-buckle-photo]'), /own buckle/i.test(BK));
    // 衬底色（赛车孔 / 衬底款才有）
    var racing = ccRacing(), ulf = cq('[data-gc-cp-underlay-field]');
    if (ulf) { ccDisp(ulf, racing); qa('input', ulf).forEach(function (i) { if (i.disabled === racing) i.disabled = !racing; }); }
    // 中切 / 翼切尺寸
    var sv = ccStrip(sty), mid = /middle cut/i.test(sv), wing = /wing cut/i.test(sv);
    [['[data-gc-cut-middle-field]', mid], ['[data-gc-cut-wing-field]', wing]].forEach(function (x) {
      var f = cq(x[0]); if (!f) return; ccDisp(f, x[1]);
      qa('input', f).forEach(function (i) { if (i.disabled === x[1]) i.disabled = !x[1]; if (x[1]) { if (!i.hasAttribute('required')) i.setAttribute('required', ''); } else { if (i.hasAttribute('required')) i.removeAttribute('required'); if (i.value) i.value = ''; } });
    });
    // 3 孔款：该皮色有 3 孔素材才出现
    var s = ccSet(), has3 = !!(s && ((s.holeBase && s.holeBase['3 Holes Rally']) || (s.holesFill && s.holesFill['3 Holes Rally'])));
    cqa('[data-gc-style-3hole]').forEach(function (c) {
      ccDisp(c, has3); var i = q('input', c);
      if (i) { if (i.disabled === has3) i.disabled = !has3; if (!has3 && i.checked) { var cl = cq('[data-gc-style][value="Classic"]'); if (cl) cl.checked = true; } }
    });
    // 表带圈：该皮色有灰度纹理才给选；「衬底色」选项只在赛车孔款；单色 / 双色（有两段遮罩）色块
    var km = cq('[data-gc-keeper-mode]');
    if (km) {
      var hasKp = !!(CC.cat && CC.cat.KGREY && CC.cat.KGREY[ccColor()]), kf = km.closest('.gc-f');
      ccDisp(kf, hasKp); if (km.disabled === hasKp) km.disabled = !hasKp;
      for (var oi = 0; oi < km.options.length; oi++) { var o = km.options[oi]; if (/underlay/i.test(o.value)) { var ok = racing && hasKp; o.hidden = !ok; o.disabled = !ok; if (!racing && o.selected) km.value = 'Match main leather color'; } }
      var custom = hasKp && /custom/i.test(km.value), spl = !!(s && s.keeperMask1 && s.keeperMask2);
      var sw = cq('[data-gc-keeper-swatch]'); if (sw) { var sng = custom && !spl; ccDisp(sw, sng); qa('input', sw).forEach(function (i) { if (i.disabled === sng) i.disabled = !sng; }); }
      [cq('[data-gc-keeper-swatch1]'), cq('[data-gc-keeper-swatch2]')].forEach(function (g) { if (!g) return; var sh = custom && spl; ccDisp(g, sh); qa('input', g).forEach(function (i) { if (i.disabled === sh) i.disabled = !sh; }); });
      var lh = CC.cat && CC.cat.LHEX ? CC.cat.LHEX[ccColor()] : null;
      if (lh) cqa('[data-gc-keeper-matchchip]').forEach(function (c) { if (c.getAttribute('data-lh') !== lh) { c.style.background = lh; c.setAttribute('data-lh', lh); } });
    }
  }
  /* 换成赛车孔款：线色 / 边油的「同色」改叫「配衬底色」并默认选上；换回普通款线色回到默认奶油色 */
  function ccStyleDefaults() {
    var sv = ccStyle(), racing = /racing|underlay/i.test(sv), was = /racing|underlay/i.test(CC.lastStyle || '');
    function rl(el, on, off) { if (!el) return; var nt = racing ? on : off; for (var i = 0; i < el.options.length; i++) { var o = el.options[i]; if (o.text.indexOf('tone-on-tone') >= 0 || o.text.indexOf('Underlay') >= 0) { if (o.text !== nt) o.text = nt; break; } } }
    rl(cq('[data-gc-stitch-mode]'), 'Recommended (matching Underlay color)', 'Recommended (matching tone-on-tone)');
    rl(cq('[data-gc-edge]'), 'Painted (matching Underlay color)', 'Painted (tone-on-tone)');
    function setSel(el, re) { if (!el) return; for (var i = 0; i < el.options.length; i++) if (re.test(el.options[i].text || el.options[i].value)) { if (el.selectedIndex !== i) el.selectedIndex = i; break; } }
    if (CC.lastStyle !== null) {
      if (racing && !was) { setSel(cq('[data-gc-stitch-mode]'), /recommend|tone-on-tone/i); setSel(cq('[data-gc-edge]'), /tone-on-tone/i); }
      else if (!racing && was) setSel(cq('[data-gc-stitch-mode]'), /default cream/i);
    }
    CC.lastStyle = sv;
  }
  /* 选择提示「— 值」 */
  function ccHints() {
    function sw(attr, selAttr, useName) {
      var r0 = cq('[' + attr + ']:checked'), t = '';
      if (r0) { if (useName) { var l = r0.closest('label'), n = l && q('.gc-sw__n', l); t = n ? n.textContent.trim() : r0.value; } else t = r0.value; }
      cqa('[' + selAttr + ']').forEach(function (s) { setT(s, t ? '— ' + t : ''); });
    }
    sw('data-gc-fbuckle', 'data-gc-fbuckle-sel'); sw('data-gc-buckle', 'data-gc-buckle-sel'); sw('data-gc-edgecolor', 'data-gc-edgecolor-sel');
    sw('data-gc-cp-underlay', 'data-gc-underlaycolor-sel'); sw('data-gc-stitch', 'data-gc-stitch-sel'); sw('data-gc-style', 'data-gc-style-sel');
    sw('data-gc-ssty', 'data-gc-ssty-sel'); sw('data-gc-tip', 'data-gc-tip-sel');
    sw('data-gc-leathercolor', 'data-gc-leathercolor-sel', true);
    sw('data-gc-keeper', 'data-gc-keeper-sel', true); sw('data-gc-keeper1', 'data-gc-keeper1-sel', true); sw('data-gc-keeper2', 'data-gc-keeper2-sel', true);
    // 下拉字段：标签后自动「— 选中文字」
    cqa('.gc-f').forEach(function (fld) {
      var s = q('select', fld), lbl = q('.gc-l', fld); if (!s || !lbl || s.closest('.gc-f') !== fld) return;
      var sp = q(':scope > .gc-auto-sel', lbl); if (!sp) { sp = document.createElement('span'); sp.className = 'gc-sel gc-auto-sel'; var gq = q(':scope > .gc-q', lbl); if (gq) lbl.insertBefore(sp, gq); else lbl.appendChild(sp); }
      var t = (s.options[s.selectedIndex] || {}).text || s.value;
      setT(sp, t && !s.disabled && vis(fld) ? ' — ' + t : '');
    });
    // 形状卡片高亮 + 提示
    cqa('.gc-cards').forEach(function (grp) {
      var ck = q('input[data-gc-form]:checked', grp);
      qa('.gc-card', grp).forEach(function (c) { var i = q('input', c), on = !!(i && i.checked); if (c.classList.contains('gc-card--on') !== on) c.classList.toggle('gc-card--on', on); });
      var fld = grp.closest('.gc-f'), lbl = fld && q('.gc-l', fld);
      if (lbl) { var sp = q(':scope > .gc-auto-sel', lbl); if (!sp) { sp = document.createElement('span'); sp.className = 'gc-sel gc-auto-sel'; lbl.appendChild(sp); } setT(sp, ck ? ' — ' + ck.value : ''); }
    });
  }
  /* 尺寸指南「?」：按标签开头匹配（参考站同一套 9 份指南） */
  function ccGuides() {
    if (!Object.keys(GUIDES).length) return;
    var done = {}; cqa('.gc-q[data-g]').forEach(function (b) { done[b.getAttribute('data-g')] = 1; });
    cqa('.gc-l').forEach(function (lbl) {
      if (q(':scope > .gc-q', lbl)) return;
      var c0 = lbl.childNodes[0], txt = ((c0 && c0.textContent) ? c0.textContent : (lbl.textContent || '')).trim();
      for (var i = 0; i < GUIDE_KEYS.length; i++) {
        var key = GUIDE_KEYS[i][1]; if (done[key] || !GUIDES[key] || txt.indexOf(GUIDE_KEYS[i][0]) !== 0) continue;
        if (key === 'length') { var ov = cq('[data-gc-len-guide]'); if (ov && GUIDES[ov.getAttribute('data-gc-len-guide')]) key = ov.getAttribute('data-gc-len-guide'); }
        var b = document.createElement('button'); b.type = 'button'; b.className = 'gc-q'; b.setAttribute('aria-label', 'Guide'); b.setAttribute('data-g', key); b.textContent = '?';
        lbl.appendChild(b); done[GUIDE_KEYS[i][1]] = 1; break;
      }
    });
  }
  /* 小结卡 + 总价 → 原生 Price 变体 */
  function ccSummary() {
    var spec = cq('[data-gc-spec]'); if (!spec) return;
    var byo = !cq('[data-gc-addons]'), rows = [], addon = 0, addonN = [];
    cqa('.gc-f').forEach(function (fld) {
      if (!vis(fld)) return;
      var le = q('.gc-l', fld); if (!le) return;
      var nm = (le.childNodes[0] ? le.childNodes[0].textContent : '').trim(); if (!nm || /^note/i.test(nm)) return;
      var s = q('select', fld), r0 = q('input[type=radio]:checked', fld), t = q('input[type=text]', fld), fi = q('input[type=file]', fld), val = '';
      var sOn = !!(s && s.value && !s.disabled);
      if (sOn) val = (s.options[s.selectedIndex] || {}).text || s.value;
      else if (r0) val = r0.value; else if (t && t.value) val = t.value; else if (fi && fi.files && fi.files.length) val = 'Attached';
      if (!val) return;
      var clean = ccStrip(val), mp = String(byo && sOn ? s.value : val).match(/\+\$([0-9.]+)/);
      if (mp) { var pp = parseFloat(mp[1]); addon += pp; addonN.push(byo ? (q('[data-gc-leatherkind]', fld) ? clean + ' leather' : clean) : { label: clean, price: pp }); }
      rows.push([nm, clean]);
    });
    var html = rows.length ? rows.map(function (x) { return '<li><span class="gc-byo-spec-k">' + esc(x[0]) + '</span><span class="gc-byo-spec-v">' + esc(x[1]) + '</span></li>'; }).join('') : '<li class="gc-byo-spec-loading">Start designing above…</li>';
    if (spec.innerHTML !== html) spec.innerHTML = html;
    var base = ccBase();
    if (!byo) {
      var kd = cq('[data-gc-leatherkind]'), KP = (CC.cat && CC.cat.KPRICE) || (CC.preview ? CC_KPRICE : null), ck = (kd && kd.value) || '';
      if (KP && KP[ck] != null) base = KP[ck] + (base - (KP['Epsom Calfskin'] || base));
      var ad = cq('[data-gc-addons]');
      if (ad) { var ah = addonN.map(function (it) { return '<div class="gc-byo-prow gc-byo-addon"><span class="gc-byo-addon-name">' + esc(it.label) + '</span><strong>+' + ccMoney(it.price) + '</strong></div>'; }).join(''); if (ad.innerHTML !== ah) ad.innerHTML = ah; }
      var bl = cq('[data-gc-baselabel]'), bp = cq('[data-gc-baseprice]');
      if (bp) setT(bp, ccMoney(base)); if (bl) setT(bl, ck ? ck : 'Strap base price');
    } else {
      var ar = cq('[data-gc-addon-row]'), at = cq('[data-gc-addon-total]'), al = cq('[data-gc-addon-label]');
      if (at) setT(at, '+' + ccMoney(addon));
      if (al && addonN.length) setT(al, addonN.join(' + '));
      if (ar) { if (addon > 0) ar.removeAttribute('hidden'); else if (!ar.hasAttribute('hidden')) ar.setAttribute('hidden', ''); }
    }
    var gr = cq('[data-gc-grand]'); if (gr) setT(gr, ccMoney(base + addon));
    ccPrice(base + addon);
  }
  // 按总价选原生「Price」变体（没有正好的就取不低于总价的最近一档，免得少收）
  function ccPrice(total) {
    var o = nativeOptions().filter(function (x) { return /^price$/i.test(x.name); })[0]; if (!o) return;
    var want = '$' + total.toFixed(2), best = null, bestV = Infinity;
    for (var i = 0; i < o.sel.options.length; i++) {
      var v = o.sel.options[i].value; if (v === want) { best = v; break; }
      var n = parseFloat(String(v).replace(/[^0-9.]/g, '')); if (n >= total - 0.001 && n < bestV) { bestV = n; best = v; }
    }
    if (best && o.sel.value !== best) { o.sel.value = best; o.sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function ccNative() {
    nativeOptions().forEach(function (o) { if (o.wrap && !o.wrap.classList.contains('gc-hide-native')) o.wrap.classList.add('gc-hide-native'); });
  }

  /* ---------- 实时预览：图层叠加（底图 / 线迹 / 边油 / 表带圈 / 孔 / 表扣 / 弯头） ---------- */
  function ccGallery() { return q('.product-information__media media-gallery') || q('media-gallery'); }
  function ccTarget() {
    var k = cq('[data-gc-leatherkind]'), kv = k ? (k.value || '') : '', c = cq('[name="properties[Color]"]:checked');
    return /epsom|lizard|togo|ostrich|swift|alligator|pueblo/i.test(kv) && !!c && !!(CC.cat && CC.cat.CT && CC.cat.CT[c.value]);
  }
  function ccPlace() {
    var cp = CC && CC.cp; if (!cp) return;
    var desk = window.innerWidth > 749;
    if (desk) { var media = q('.product-information__media'); if (media && cp.parentElement !== media) media.insertBefore(cp, media.firstChild); cp.style.top = '20px'; cp.style.margin = '0 auto 14px'; cp.style.maxWidth = 'min(100%, 740px)'; cp.style.zIndex = '30'; }
    else { var top = cq('.gc-byo-top'); if (top && cp.nextElementSibling !== top) top.parentNode.insertBefore(cp, top); cp.style.margin = '0 auto 12px'; cp.style.maxWidth = 'none'; cp.style.zIndex = '6'; ccStick(); }
    cp.style.position = 'sticky'; cp.style.width = '100%';
    if (!CC.revealed) cp.style.display = 'none';
  }
  var ccStickRaf = 0;
  function ccStick() {
    if (ccStickRaf || !CC || !CC.cp) return;
    ccStickRaf = requestAnimationFrame(function () {
      ccStickRaf = 0; if (!CC.revealed || window.innerWidth > 749) return;
      var h = q('.header-section') || q('header.shopify-section') || q('header-component') || q('header'), hb = 0;   // Horizon 吸顶的是 header.header-section（header-component 本身是 static）
      if (h) { var hr = h.getBoundingClientRect(); if (getComputedStyle(h).position === 'sticky' || getComputedStyle(h).position === 'fixed' || hr.top >= 0) hb = Math.max(0, hr.bottom); }
      CC.cp.style.top = Math.max(8, hb + 6) + 'px';
    });
  }
  function ccReveal(on) {
    var cp = CC.cp; if (!cp) return;
    var mg = ccGallery(), media = q('.product-information__media'), desk = window.innerWidth > 749;
    if (on) {
      if (cp.style.display !== 'block') cp.style.display = 'block';
      // Horizon 换变体（Price）会重绘相册 → 每次刷新都要确认相册还藏着（收起预览时放出来）
      if (desk) {
        if (media && media.style.getPropertyValue('display')) media.style.removeProperty('display');
        if (mg) { if (cp.classList.contains('gc-cp--collapsed')) { if (mg.style.getPropertyValue('display')) mg.style.removeProperty('display'); } else if (mg.style.getPropertyValue('display') !== 'none') mg.style.setProperty('display', 'none', 'important'); }
      } else {
        if (media && media.style.getPropertyValue('display') !== 'none') media.style.setProperty('display', 'none', 'important');
        var note = q('.gc-cp__cap--note', cp), top = cq('.gc-byo-top');
        if (note && top && !note.classList.contains('gc-cp__cap--mob')) { note.classList.add('gc-cp__cap--mob'); top.parentNode.insertBefore(note, top); }
      }
    } else if (CC.revealed) {
      cp.style.display = 'none';
      if (mg) mg.style.removeProperty('display'); if (media) media.style.removeProperty('display');
    }
    CC.revealed = on;
  }
  function ccColHex(v, map, dflt) { return (map && map[v]) || dflt; }
  function ccUnderlay() { var s = cq('[name="properties[Underlay Color]"]:checked'); return ccColHex(s ? s.value : 'Cream', CC.cat.UHEX, '#efe6d0'); }
  function ccStitchHex() {
    var m = cq('[name="properties[Stitch Color]"]'), mv = m ? m.value : '';
    if (/custom/i.test(mv)) { var s = cq('[name="properties[Stitch Colour Choice]"]:checked'); if (s && CC.cat.SHEX[s.value]) return CC.cat.SHEX[s.value]; }
    if (/tone-on-tone|recommend/i.test(mv)) return ccRacing() ? ccUnderlay() : (CC.cat.LHEX[ccColor()] || '#1a1a1a');
    return '#efe6d0';
  }
  function ccEdgeHex() {
    var ef = cq('[name="properties[Edge Finishing]"]'), em = ef ? ef.value : '';
    if (/tone-on-tone|underlay/i.test(em)) return ccRacing() ? ccUnderlay() : (CC.cat.LHEX[ccColor()] || '#1a1a1a');
    var s = cq('[name="properties[Edge Color]"]:checked'); return ccColHex(s ? s.value : '', CC.cat.EDHEX, '#1a1a1a');
  }
  function ccKeeperHex(n) {
    var m = cq('[data-gc-keeper-mode]'), mv = m ? m.value : '';
    if (/underlay/i.test(mv)) return ccRacing() ? ccUnderlay() : null;
    if (/custom/i.test(mv)) {
      var s = cq('input[data-gc-keeper' + (n || '') + ']:checked');
      if (s && !s.hasAttribute('data-gc-keeper-match')) { var sp = s.parentNode && q('.gc-sw-color', s.parentNode); if (sp) { var bg = getComputedStyle(sp).backgroundColor; if (bg && bg !== 'rgba(0, 0, 0, 0)') return bg; } }
    }
    return null;
  }
  function ccPaint() {
    var cp = CC.cp; if (!cp || !CC.cat) return;
    var s = ccSet(); if (!s) return;
    function MK(el, u) { if (!el || !u || el.getAttribute('data-mk') === u) return; el.style.webkitMaskImage = 'url(' + u + ')'; el.style.maskImage = 'url(' + u + ')'; el.setAttribute('data-mk', u); }
    function BGI(el, u) { if (!el || el.getAttribute('data-bgi') === u) return; el.style.backgroundImage = 'url(' + u + ')'; el.setAttribute('data-bgi', u); }
    function BGC(el, c) { if (!el) return; c = c == null ? '' : String(c); if (el.getAttribute('data-bgc') === c) return; el.style.background = c; el.setAttribute('data-bgc', c); }
    function OPA(el, o) { if (!el) return; o = String(o); if (el.getAttribute('data-op') === o) return; el.style.opacity = o; el.setAttribute('data-op', o); }
    function BLND(el, m) { if (!el) return; m = String(m); if (el.getAttribute('data-bl') === m) return; el.style.mixBlendMode = m; el.setAttribute('data-bl', m); }
    var L = function (a) { return q('[data-gc-cp-' + a + ']', cp); };
    var sv = ccStrip(ccStyle()), baseU = (s.holeBase && s.holeBase[sv]) ? s.holeBase[sv] : s.base;
    var bi = q('.gc-cp__base', cp); if (bi && baseU && bi.getAttribute('src') !== baseU) bi.src = baseU;
    // 线迹
    var st = L('stitch');
    if (st) {
      var ss = cq('[name="properties[Stitch Style]"]:checked'), ssv = ss ? ccStrip(ss.value) : 'Classic stitches';
      var isCut = /wing cut|middle cut/i.test(sv) && !!(s.holeBase && (s.holeBase['Wing Cut'] || s.holeBase['Middle Cut']));
      var u = (isCut && s.cutStitch) ? (s.cutStitch[ssv] || s.cutStitch['Classic stitches']) : ((s.stitch || {})[ssv] || (s.stitch || {})['Classic stitches']);
      if (u) MK(st, u); BGC(st, ccStitchHex());
    }
    // 边油
    var ed = L('edge'); if (ed) { if (s.edge) MK(ed, s.edge); BGC(ed, ccEdgeHex()); OPA(ed, '1'); }
    // 表带圈（单段 / 两段）
    var kp = L('keeper'), kg = L('keepergrey'), kp2 = L('keeper2'), kg2 = L('keepergrey2'), gt = CC.cat.KGREY[ccColor()];
    function SK(cl, gl, mk, hx) {
      if (!cl) return; MK(cl, mk); if (gl) MK(gl, mk);
      if (hx && gt) { if (gl) { BGI(gl, gt); OPA(gl, '1'); } BLND(cl, 'overlay'); BGC(cl, hx); OPA(cl, '1'); }
      else if (hx) { if (gl) OPA(gl, '0'); BLND(cl, 'normal'); BGC(cl, hx); OPA(cl, '1'); }
      else { OPA(cl, '0'); if (gl) OPA(gl, '0'); }
    }
    if (kp && s.keeperMask1 && s.keeperMask2) { SK(kp, kg, s.keeperMask1, ccKeeperHex(1)); SK(kp2, kg2, s.keeperMask2, ccKeeperHex(2)); }
    else { if (kp2) OPA(kp2, '0'); if (kg2) OPA(kg2, '0'); if (kp) { var kh = gt ? ccKeeperHex('') : null; if (kh && s.keeperMask) SK(kp, kg, s.keeperMask, kh); else { OPA(kp, '0'); if (kg) OPA(kg, '0'); } } }
    // 孔（赛车孔填衬底色；拉力孔有阴影 + 白填充）
    var hm = s.holes ? s.holes[sv] : null, hsh = s.holesShadow ? s.holesShadow[sv] : null, hff = s.holesFill ? s.holesFill[sv] : null;
    var ho = L('holes'); if (ho) { if (hm && !/rally/i.test(sv)) { MK(ho, hm); BGC(ho, ccUnderlay()); OPA(ho, '1'); } else OPA(ho, '0'); }
    var hs = L('holeshadow'); if (hs) { if (/rally/i.test(sv) && hsh) { MK(hs, hsh); BGC(hs, ccEdgeHex()); OPA(hs, '1'); } else OPA(hs, '0'); }
    var hf = L('holefill'); if (hf) { if (hff) { MK(hf, hff); BGC(hf, /rally/i.test(sv) ? '#ffffff' : ccUnderlay()); OPA(hf, '1'); } else OPA(hf, '0'); }
    // 表扣
    var bk = q('[data-gc-cp-buckle]', cp);
    if (bk) {
      var bs = cq('[name="properties[Buckle Finish]"]:checked'), bv = bs ? bs.value : 'Silver';
      if (/own buckle/i.test(bv)) bk.style.display = 'none';
      else { var key = CC.cat.BKMAP[bv] || 'silver', bu = (s.buckle || {})[key] || (key.indexOf('heavy-') === 0 ? (s.buckle || {})[key.slice(6)] : null); if (bu) { bk.style.display = 'block'; if (bk.getAttribute('src') !== bu) { bk.decoding = 'async'; bk.src = bu; } } else bk.style.display = 'none'; }
    }
    // 弯头
    var cv = L('curve');
    if (cv) { var yes = /yes/i.test((cq('[name="properties[Curved End]"]') || {}).value || ''), cu = CC.cat.CURVE[baseU] || CC.cat.CURVE_DEFAULT; if (yes && cu) { MK(cv, cu); OPA(cv, '1'); } else OPA(cv, '0'); }
    // 预热当前皮色的图层（参考站会全量预载几千张，这里只预载当前这套）
    var sig = ccColor(); if (CC.painted !== sig) { CC.painted = sig; var urls = []; (function add(o) { for (var k in o) { var v = o[k]; if (typeof v === 'string') urls.push(v); else if (v && typeof v === 'object') add(v); } })(s); var i = 0; (function nx() { if (i >= urls.length) return; var im = new Image(); im.onload = im.onerror = function () { setTimeout(nx, 60); }; im.src = urls[i++]; })(); }
  }
  function ccZoom() {
    var stage = CC && CC.cp && q('.gc-cp__stage', CC.cp); if (!stage) return;
    var ov = document.createElement('div'); ov.className = 'gc-cp__zoom';
    var box = document.createElement('div'); box.className = 'gc-cp__zoombox'; box.appendChild(stage.cloneNode(true));
    var x = document.createElement('div'); x.className = 'gc-cp__zoomclose'; x.innerHTML = '×';
    ov.appendChild(box); ov.appendChild(x); document.body.appendChild(ov);
    function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); }
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); }); x.addEventListener('click', function (e) { e.stopPropagation(); close(); });
  }
  function ccRefresh() {
    if (!CC) return;
    ccStyleDefaults(); ccKinds(); ccColorsets(); ccLining(); ccReveals(); ccHints(); ccGuides(); ccSummary(); ccNative();
    if (CC.cp) { ccPlace(); var t = ccTarget(); ccReveal(t); if (t) ccPaint(); }
  }

  /* ---------- 总刷新 ---------- */
  function refresh() {
    var r = root(); if (!r) return;
    if (isKf()) { kfInit(); kfRefresh(); kfNative(); pageBits(); wireForm(); return; }
    if (isCustom()) { ccInit(); ccRefresh(); pageBits(); wireForm(); return; }
    // 衬里默认选第一个（参考站同款）
    var lin = qa('input[data-gc-lining]', r);
    if (lin.length && !lin.some(function (i) { return i.checked; })) lin[0].checked = true;
    updThickness();
    var th = q('[data-gc-thickness]', r);
    show(q('[data-gc-adv-thickness]', r), /request/i.test(th ? th.value : ''));
    var lug = q('[data-gc-lugprop]', r); if (lug) show(q('[data-gc-adv-lug]', r), /advance/i.test(selText(lug)));
    var L = q('[data-gc-length]', r); if (L) show(q('[data-gc-adv-length]', r), /advance/i.test(L.value));
    var E = q('[data-gc-edge]', r); if (E) show(q('[data-gc-edge-color]', r), /other/i.test(E.value));
    var SM = q('[data-gc-stitch-mode]', r); if (SM) show(q('[data-gc-stitch-swatch]', r), /custom/i.test(SM.value));
    var SSM = q('[data-gc-sstyle-mode]', r); if (SSM) show(q('[data-gc-sstyle-swatch]', r), /custom/i.test(SSM.value));
    var bk = q('[data-gc-buckle]:checked', r); show(q('[data-gc-buckle-photo]', r), !!bk && /own buckle/i.test(bk.value));
    swHint('data-gc-buckle', 'data-gc-buckle-sel');
    swHint('data-gc-lining', 'data-gc-lining-sel');
    swHint('data-gc-stitch', 'data-gc-stitch-sel');
    swHint('data-gc-sstyle', 'data-gc-sstyle-sel');
    swHint('data-gc-edgecolor', 'data-gc-edgecolor-sel');
    autoHints();
    nativeSync();
    injectGuides();
    pageBits();
    wireForm();
  }

  /* ---------- 页面级：scope 类 / 原生标签星号 / 数量标签 / 提示挪到加购下 / Customize 按钮 ---------- */
  function pageBits() {
    var r = root(); if (!r) return;
    var sec = r.closest('.shopify-section'); if (sec && !sec.classList.contains('gc-scope')) sec.classList.add('gc-scope');
    nativeOptions().forEach(function (o) {
      if (!o.lbl || (o.wrap && o.wrap.classList.contains('gc-hide-native'))) return;
      var star = o.lbl.querySelector(':scope > .gc-req');
      if (!star) { star = document.createElement('span'); star.className = 'gc-req'; star.textContent = '*'; o.lbl.appendChild(star); }
      else if (star !== o.lbl.lastElementChild) o.lbl.appendChild(star);   // 保持 ? 在前、* 在后
    });
    var qw = q('.gc-scope .quantity-selector-wrapper');
    if (qw && !(qw.previousElementSibling && qw.previousElementSibling.classList.contains('gc-qty-l'))) {
      var ql = document.createElement('span'); ql.className = 'gc-qty-l'; ql.innerHTML = 'Quantity<span class="gc-req">*</span>';
      qw.parentNode.insertBefore(ql, qw);
    }
    var note = q('.gc-atc-note'), atc = q('.gc-scope add-to-cart-component');
    if (note && atc && atc.nextElementSibling !== note) atc.parentNode.insertBefore(note, atc.nextSibling);
    if ((r.getAttribute('data-gc-kind') || '') === 'strap') {
      var mg = q('.gc-scope media-gallery') || q('media-gallery');
      if (mg && !q('.gc-cust-btn', mg)) {
        if (getComputedStyle(mg).position === 'static') mg.style.position = 'relative';
        var a = document.createElement('a'); a.className = 'gc-cust-btn'; a.href = '/pages/3d-custom-watch-strap';
        a.setAttribute('aria-label', 'Customize your own strap'); a.title = 'Customize your own';
        a.innerHTML = '<span class="gc-cust-btn__ico"><svg viewBox="0 0 24 24" fill="none" stroke="#6b655c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg></span><span class="gc-cust-btn__txt">Customize your own</span>';
        mg.appendChild(a);
      }
    }
  }

  /* ---------- 加购校验 ---------- */
  function missing() {
    var r = root(); if (!r) return [];
    var out = [];
    qa('select[required], input[type=text][required], textarea[required]', r).forEach(function (s) { if (vis(s) && !s.disabled && !s.value) out.push(s); });
    qa('input[type=file][required]', r).forEach(function (f) { if (vis(f) && !f.disabled && (!f.files || !f.files.length)) out.push(f); });
    var g = {};
    qa('input[type=radio][required]', r).forEach(function (x) { (g[x.name] = g[x.name] || []).push(x); });
    Object.keys(g).forEach(function (n) {
      var any = g[n].some(function (x) { return x.checked; });
      var fld = g[n][0].closest('.gc-f');
      if (fld && vis(fld) && !any && !g[n][0].disabled) out.push(g[n][0]);
    });
    return out;
  }
  function clearErr() { qa('.gc-f.gc-err').forEach(function (f) { f.classList.remove('gc-err'); }); }
  function guard(e) {
    if (isKf()) {
      refresh(); qa('.gc-invalid').forEach(function (x) { x.classList.remove('gc-invalid'); });
      var bad = kValidate();
      if (bad) { e.preventDefault(); e.stopImmediatePropagation(); if (bad[0]) { bad[0].classList.add('gc-invalid'); try { bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {} } kToast(bad[1]); }
      else kToast('Adding to your cart…', true);
      return;
    }
    refresh(); clearErr();
    var m = missing(); if (!m.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    m.forEach(function (x) { var f = x.closest('.gc-f'); if (f) f.classList.add('gc-err'); });
    var first = m[0].closest('.gc-f') || m[0];
    try { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {}
  }
  var ATC = 'add-to-cart-component button, button[name="add"], .add-to-cart-button, .product-form__submit, [data-testid="add-to-cart"]';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(ATC); if (!b || !root()) return;
    var f = productForm(); if (f && b.form && b.form !== f) return;
    guard(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = productForm(); if (!f || e.target !== f || !root()) return;
    guard(e);
  }, true);
  document.addEventListener('change', function (e) { var f = e.target.closest && e.target.closest('.gc-f.gc-err'); if (f) f.classList.remove('gc-err'); }, true);

  /* ---------- 放大灯箱 ---------- */
  var lb;
  function openZoom(src, name) {
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'gc-lb';
      lb.innerHTML = '<button type="button" class="gc-lb__x" aria-label="Close">&times;</button><div class="gc-lb__in"><img alt=""><p></p></div>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function () { lb.style.display = 'none'; });
    }
    q('img', lb).src = src; q('p', lb).textContent = name || '';
    lb.style.display = 'flex';
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest && e.target.closest('[data-gc-zoom]'); if (!z) return;
    e.preventDefault(); e.stopPropagation();
    openZoom(z.getAttribute('data-gc-zoom'), z.getAttribute('data-gc-zoom-name'));
  }, true);

  /* ---------- 尺寸指南 ---------- */
  var GUIDES = {}, gm, gmT, gmB;
  function initGuides() {
    var host = q('[data-gc-guides]'); if (!host) return;
    try { GUIDES = JSON.parse(host.textContent) || {}; } catch (e) { GUIDES = {}; }
    gm = q('[data-gc-gm]'); if (!gm) return;
    if (gm.parentNode !== document.body) document.body.appendChild(gm);
    gmT = q('[data-gc-gt]', gm); gmB = q('[data-gc-gb]', gm);
    gm.addEventListener('click', function (e) { if (e.target === gm) closeG(); });
    q('[data-gc-gx]', gm).addEventListener('click', closeG);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeG(); if (lb) lb.style.display = 'none'; } });
  }
  function openG(k) { if (!gm || !GUIDES[k]) return; gmT.textContent = GUIDES[k].title; gmB.innerHTML = GUIDES[k].body; gm.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeG() { if (!gm || gm.hidden) return; gm.hidden = true; gmB.innerHTML = ''; document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gc-q[data-g]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); openG(b.getAttribute('data-g'));
  }, true);
  function injectGuides() {
    if (!Object.keys(GUIDES).length) return;
    var done = {}; qa('.gc-q[data-g]').forEach(function (b) { done[b.getAttribute('data-g')] = 1; });
    nativeOptions().forEach(function (o) {
      if (!o.lbl || o.lbl.querySelector('.gc-q')) return;
      for (var i = 0; i < GUIDE_KEYS.length; i++) {
        var key = GUIDE_KEYS[i][1];
        if (done[key] || !GUIDES[key]) continue;
        if (o.name.indexOf(GUIDE_KEYS[i][0]) === 0) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'gc-q'; b.setAttribute('aria-label', 'Guide'); b.setAttribute('data-g', key); b.textContent = '?';
          var st0 = o.lbl.querySelector(':scope > .gc-req'); if (st0) o.lbl.insertBefore(b, st0); else o.lbl.appendChild(b);
          done[key] = 1; break;
        }
      }
    });
  }

  /* ---------- 启动 ---------- */
  var tmr;
  function soon(ms) { clearTimeout(tmr); tmr = setTimeout(refresh, ms || 60); }
  function init() {
    if (!root()) return;
    initGuides(); refresh();
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('[data-gc-cfg]')) { soon(30); return; }
      if (t.closest('variant-picker, variant-picker-component, .variant-option, .product-form__input, variant-selects')) { soon(80); setTimeout(refresh, 450); setTimeout(refresh, 1000); setTimeout(refresh, 1800); }
    });
    // Horizon 换变体会重渲染选择器 → 观察后重新套样式 / 隐藏 Buckle Type
    if (window.MutationObserver) {
      var host = q('variant-picker') || q('variant-picker-component') || (q('select[name^="options["]') && q('select[name^="options["]').closest('section, .shopify-section'));
      if (host) new MutationObserver(function () { soon(120); }).observe(host, { childList: true, subtree: true });
    }
    setTimeout(refresh, 700); setTimeout(refresh, 1800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
